export enum MuiSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}
